import parsePhoneNumber from 'libphonenumber-js';

const contactPhoneNumber = parsePhoneNumber('+18564859703')!;

export const CONTACT_INTERNATIONAL_PHONE_NUMBER = contactPhoneNumber.formatInternational(); // +1 856 485 9703
export const CONTACT_NATIONAL_PHONE_NUMBER = contactPhoneNumber.formatNational(); // (856) 485-9703
export const CONTACT_URI_PHONE_NUMBER = contactPhoneNumber.getURI(); // tel:+18564859703

const marketingSupportPhoneNumber = parsePhoneNumber('+19294332348')!;

export const MARKETING_SUPPORT_PHONE_NUMBER_DISPLAY = marketingSupportPhoneNumber.formatInternational(); // +1 929 433 2348
export const MARKETING_SUPPORT_PHONE_NUMBER_URI = marketingSupportPhoneNumber.getURI(); // tel:+19294332348
export const SUPPORT_URL = 'https://www.metropolis.io/support';
export const TERMS_OF_SERVICE_URL = 'https://metropolis.io/terms/';
export const PRIVACY_POLICY_URL = 'https://metropolis.io/privacy/';
export const PRODUCT_SUPPORT_TICKET_LINK =
  'https://metropolisio.atlassian.net/servicedesk/customer/portal/56';

export const SMS_PHONE_NUMBER = '676547';

export const APP_STORE_URL =
  'https://apps.apple.com/us/app/metropolis-remarkable-parking/id1556970037';

// Site group-specific phone number overrides for exit displays
// Maps siteGroupId to local office phone numbers
const SITE_GROUP_PHONE_NUMBER_OVERRIDES: Record<number, string> = {
  588: '+16156783628', // Target Westwood
  2546: '+12102073490', // SAT - San Antonio International Airport
  3133: '+14792051119', // XNA - Northwest Arkansas National Airport
  3837: '+13015672277', // Spirit Lot
  3843: '+19157717990', // ELP - El Paso International Airport
  3890: '+17075835130', // Sonoma Airport
};

/**
 * Get the appropriate contact phone number for a site group.
 * Returns site group-specific override if available, otherwise returns default Metropolis support number.
 */
export const getContactPhoneNumberForSiteGroup = (siteGroupId?: number) => {
  if (siteGroupId && SITE_GROUP_PHONE_NUMBER_OVERRIDES[siteGroupId]) {
    const sitePhoneNumber = parsePhoneNumber(SITE_GROUP_PHONE_NUMBER_OVERRIDES[siteGroupId]);
    if (sitePhoneNumber) {
      return {
        international: sitePhoneNumber.formatInternational(),
        national: sitePhoneNumber.formatNational(),
        uri: sitePhoneNumber.getURI(),
      };
    }
  }

  return {
    international: CONTACT_INTERNATIONAL_PHONE_NUMBER,
    national: CONTACT_NATIONAL_PHONE_NUMBER,
    uri: CONTACT_URI_PHONE_NUMBER,
  };
};
